import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DesignAngularKitModule, ItNotificationService } from 'design-angular-kit';
import { Attachment } from '../../../../models/attachment.dto';
import { AttachmentService } from '../../../../services/attachment.service';

@Component({
  selector: 'app-attach-card',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  templateUrl: './attach-card.component.html',
  styleUrl: './attach-card.component.scss',
})
export class AttachCardComponent {
  @Input() attachment!: Attachment;
  @Input() canDelete = false;
  @Output() refresh = new EventEmitter<boolean>();

  constructor(
    private attachmentService: AttachmentService, 
    private notification: ItNotificationService) {}

  downloadAttachment(): void {
    //const uuid = this.attachment.document?.uuid;
    this.attachmentService.downloadAttachment(this.attachment.url).subscribe({
      next: (blob: Blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = this.attachment.name || 'download';
        a.click();
        URL.revokeObjectURL(objectUrl);
      },
      error: (err) => {
        console.error('Errore nel download dell’allegato', err);
      },
    });
  }

  removeAttachment(): void {
    this.attachmentService.deleteAttachment(this.attachment.uuid).subscribe({
      next: () => {
        this.notification.success('Il file è stato cancellato con successo.');
        this.refresh.emit(true);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }
}
